import { createSlice } from '@reduxjs/toolkit';

const savedLocation = localStorage.getItem('userLocation');

const initialState = {
    location: savedLocation
        ? JSON.parse(savedLocation)
        : { latitude: null, longitude: null, address: '' },
    isLoadinglocation: false,
    error: null,
};

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setLocation(state, action) {
            state.location = action.payload;
            localStorage.setItem('userLocation', JSON.stringify(action.payload));
        },
        setIsLoadingLocation(state, action) {
            state.isLoadinglocation = action.payload;
        },
        setError(state, action) {
            state.error = action.payload;
        },
    },
});

export const { setLocation, setIsLoadingLocation, setError } = locationSlice.actions;

export default locationSlice.reducer;
